/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface AddContactRequest {
  additional_fields?: AdditionalField[];
  /** Common address entity that used almost everywhere in Ingrid's API. */
  address?: Address;
  email?: string;
  location_ref?: string;
  notes?: string;
  phone?: string;
  site_id?: string;
}

export interface AddContactResponse {
  contact?: Contact;
}

export interface AdditionalField {
  key?: string;
  value?: string;
}

export interface AdditionalFields {
  additional_fields?: AdditionalField[];
}

/** Common address entity that used almost everywhere in Ingrid's API. */
export interface Address {
  /** List of address lines part of address such as street and building number */
  address_lines?: string[];
  /** Number of the apartment. */
  apartment_number?: string;
  /**
   * Attention field. Can be used to indicate an employee if the address is a
   * company address [optional]
   */
  attn?: string;
  /** in the UK some buildings do not have a number, only a name */
  building_name?: string;
  /** Care of part of address usually written as `c/o` [optional] */
  care_of?: string;
  /** Name of the city */
  city?: string;
  /**
   * Geolocation coordinates of the address. If reverse geolocation lookup of the
   * address was successful this property will be populated. If coordinates are
   * available they will be used to in service point search. In case of
   * `search_address` coordinates can also be set by merchant if known.
   */
  coordinates?: Coordinates;
  /**
   * Country should be specified as two uppercase letters (ISO Alpha-2).
   * Example `SE` for Sweden, `ES` for Spain.
   */
  country?: string;
  /** The door code to the main entrance of the building if applicable [optional] */
  door_code?: string;
  /** Floor number [optional] */
  floor_number?: string;
  /** Customer or company name */
  name?: string;
  /** ID of the PO Box [optional] */
  po_box_id?: string;
  /** Postal code (or zipcode in US) */
  postal_code?: string;
  /** Region can be a state or a province [optional] */
  region?: string;
  /** Name of the street. */
  street?: string;
  /** Number of the street. */
  street_number?: string;
  /**
   * Further division of regions. Example countries are GB, IE, IT, LT, MX
   * For example for The Republic Of Ireland there are 4 provinces (regions),
   * e.g. `Connacht` and 26 counties (subregions), e.g. `Galway`
   * Format is ISO 3166 where applicable, exceptions are e.g. Mexico [optional]
   */
  subregion?: string;
}

export interface Any {
  "@type"?: string;
  [key: string]: any;
}

/** Contact info */
export interface Contact {
  additional_fields?: AdditionalField[];
  /** Common address entity that used almost everywhere in Ingrid's API. */
  address?: Address;
  created_at?: string;
  email?: string;
  id?: string;
  location_ref?: string;
  notes?: string;
  phone?: string;
  site_id?: string;
  updated_at?: string;
}

/** Geolocation coordinates */
export interface Coordinates {
  /**
   * Latitude
   * @format double
   */
  lat?: number;
  /**
   * Longitude
   * @format double
   */
  lng?: number;
}

export interface DeleteContactsRequest {
  contact_ids?: string[];
  site_id?: string;
}

export interface DeleteContactsResponse {
  /** @format int32 */
  count?: number;
}

export interface EditContactRequest {
  additional_fields?: AdditionalFields;
  /** Common address entity that used almost everywhere in Ingrid's API. */
  address?: Address;
  email?: string;
  id?: string;
  location_ref?: string;
  notes?: string;
  phone?: string;
  site_id?: string;
}

export interface EditContactResponse {
  contact?: Contact;
}

export interface GetContactResponse {
  contact?: Contact;
}

export interface ImportContactsRequest {
  /** @format byte */
  data?: string;
  site_id?: string;
}

export interface ImportContactsResponse {
  contacts?: Contact[];
  /** @format int64 */
  count?: string;
}

export interface ListContactsResponse {
  contacts?: Contact[];
  /** @format int64 */
  count?: string;
}

export interface Status {
  /** @format int32 */
  code?: number;
  details?: Any[];
  message?: string;
}

import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({ ...axiosConfig, baseURL: axiosConfig.baseURL || "/v1/address_book" });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title Address_Book API
 * @version 1.0
 * @baseUrl /v1/address_book
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @name AddressBookAddContact
   * @summary Add contact to address book.
   * @request POST:/contacts.add
   * @secure
   */
  addressBookAddContact = (body: AddContactRequest, params: RequestParams = {}) =>
    this.request<AddContactResponse, Status>({
      path: `/**/contacts.add`,
      method: "POST",
      body: body,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * No description
   *
   * @name AddressBookDeleteContacts
   * @summary Soft delete contacts from address book.
   * @request POST:/contacts.delete
   * @secure
   */
  addressBookDeleteContacts = (body: DeleteContactsRequest, params: RequestParams = {}) =>
    this.request<DeleteContactsResponse, Status>({
      path: `/**/contacts.delete`,
      method: "POST",
      body: body,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * No description
   *
   * @name AddressBookEditContact
   * @summary Edit contact in address book.
   * @request POST:/contacts.edit
   * @secure
   */
  addressBookEditContact = (body: EditContactRequest, params: RequestParams = {}) =>
    this.request<EditContactResponse, Status>({
      path: `/**/contacts.edit`,
      method: "POST",
      body: body,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * No description
   *
   * @name AddressBookGetContact
   * @summary Get a Contact by id.
   * @request GET:/contacts.get
   * @secure
   */
  addressBookGetContact = (
    query?: {
      id?: string;
      site_id?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<GetContactResponse, Status>({
      path: `/**/contacts.get`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * No description
   *
   * @name AddressBookListContacts
   * @summary List contacts in the address book.
   * @request GET:/contacts.list
   * @secure
   */
  addressBookListContacts = (
    query?: {
      site_id?: string;
      query?: string;
      /** @format uint64 */
      "pagination.offset"?: number;
      /** @format uint64 */
      "pagination.limit"?: number;
      /**
       * order_by_direction determines the ordering of results based on the
       * contact created_at field. [optional, defaults to descending]
       * @default "DESCENDING"
       */
      order_by_direction?: "DESCENDING" | "ASCENDING";
    },
    params: RequestParams = {},
  ) =>
    this.request<ListContactsResponse, Status>({
      path: `/**/contacts.list`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  contactsImport = {
    /**
     * No description
     *
     * @name AddressBookImportContacts
     * @summary Import contacts from uploaded file.
     * @request POST:/contacts.import
     * @secure
     */
    addressBookImportContacts: (body: ImportContactsRequest, params: RequestParams = {}) =>
      this.request<ImportContactsResponse, Status>({
        path: `/contacts.import`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
}
